import React from "react"
import { Chip, ChipProps } from "@mui/material"

export type PrimitiveChipProps = ChipProps

export const PrimitiveChip = (props: PrimitiveChipProps) => {
	return <Chip {...props} />
}
